import { render, staticRenderFns } from "./businessLicense.vue?vue&type=template&id=0c2eb82b&scoped=true"
import script from "./businessLicense.vue?vue&type=script&lang=js"
export * from "./businessLicense.vue?vue&type=script&lang=js"
import style0 from "./businessLicense.vue?vue&type=style&index=0&id=0c2eb82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2eb82b",
  null
  
)

export default component.exports